/* import __COLOCATED_TEMPLATE__ from './view-replacement-card-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();